import { useEffect, useState } from "react";
import { createPortal } from "react-dom";

const Portal = ({ children, parentStyle, portalId }) => {
  const [container] = useState(() => {
    const el = document.createElement("div");
    el.id = portalId;
    el.style.position = "fixed";
    el.style.top = "0px";
    el.style.left ="0px"
    el.style.zIndex = parentStyle.customIndex.zIndex
    return el;
  });

  useEffect(() => {
    document.body.appendChild(container);
    return () => {
      document.body.removeChild(container);
    };
  }, [container]);

  return createPortal(children, container);
};

export default Portal;